"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveRecognitionPayRequest = void 0;
var ActiveRecognitionPayRequest = /** @class */ (function () {
    function ActiveRecognitionPayRequest() {
    }
    return ActiveRecognitionPayRequest;
}());
exports.ActiveRecognitionPayRequest = ActiveRecognitionPayRequest;
;
//# sourceMappingURL=activeRecognitionPay.request.js.map